module.exports = __webpack_public_path__ + "img/img-logo-Footer.c8239e38.png";